import { render } from "./RecordPlayerModal.vue?vue&type=template&id=fa52ea20&lang=pug"
import script from "./RecordPlayerModal.vue?vue&type=script&lang=js"
export * from "./RecordPlayerModal.vue?vue&type=script&lang=js"
script.render = render

export default script